"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const pricebrand02 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-pricebrand02` : '') + (description ? ` desc-pricebrand02` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-pricebrand02"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-pricebrand02"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5 37.5C5 55.45 19.55 70 37.5 70S70 55.45 70 37.5 55.45 5 37.5 5 5 19.55 5 37.5Z",
    fill: "#FFCCD8",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#E90B5A"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 33.5C0 14.998 14.998 0 33.5 0 52.002 0 67 14.998 67 33.5 67 52.002 52.002 67 33.5 67 14.998 67 0 52.002 0 33.5ZM33.5 2C16.103 2 2 16.103 2 33.5S16.103 65 33.5 65 65 50.897 65 33.5 50.897 2 33.5 2Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.5 21.5a5.5 5.5 0 1 0 0 11A7.5 7.5 0 1 1 26 40a1 1 0 1 1 2 0 5.5 5.5 0 1 0 5.5-5.5A7.5 7.5 0 1 1 41 27a1 1 0 1 1-2 0 5.5 5.5 0 0 0-5.5-5.5Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.5 15.167a1 1 0 0 1 1 1V20.5a1 1 0 1 1-2 0v-4.333a1 1 0 0 1 1-1ZM33.5 45.5a1 1 0 0 1 1 1v4.333a1 1 0 1 1-2 0V46.5a1 1 0 0 1 1-1Z"
  }))));
};
var _default = exports.default = pricebrand02;